import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';
import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import { ScrollRestoration } from "react-router-dom"

const navigation = [
    { id: 1, name: 'Nos recommandations', to: '/strategie-retraite/' , icon: ArrowLongDownIcon},
    { id: 2, name: 'Bilans retraite', to: '/bilan-retraite/' , icon: ArrowLongDownIcon},
    { id: 3, name: 'Articulation chômage / retraite', to: '/articulation-chomage-retraite/' , icon: ArrowLongDownIcon},
    { id: 4, name: 'Des solutions d\'optimisation', to: '/solutions-optimisation/' , icon: ArrowLongDownIcon},
    { id: 6, name: 'Des conférences spécifiques', to: '/nos-conferences/' , icon: ArrowLongDownIcon},
    { id: 7, name: 'Liquidations de retraite', to: '/liquidations-retraite/' , icon: ArrowLongDownIcon},
]

const context = [   
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900">Etablissement de bilans avec intégration des périodes travaillées à l'étranger :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Selon l'application des conventions bilatérales de Sécurité sociale </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900">Etudes comparatives au niveau de la pension française des salariés du privé, entre :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> L'adhésion à la CFE ou non </span>,
            },
            {
                "subtitle": "",
                "text": <span> L'adhésion à l'AGIRC-ARRCO International ou une pension par capitalisation </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900">Lors d'un retour d'expatriation :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Possibilité de calculs du \u00abmanque à gagner\u00bb en cas de non adhésion contractualisée à la CFE ou  à l'AGIRC-ARRCO International </span>,
            },  
            {
                "subtitle": "",
                "text": <span> Calcul des cotisations rétroactives en cas d'adhésion tardive à l'AGIRC-ARRCO International </span>,
            },          
        ]
    },    
]

export default function Expatriation() {
   

    return (
        <>
            <Title classNames="bg-expatriation bg-cover lg:bg-right bg-left" title="La retraite et l'expatriation" />

            <Subtitle subtitle="Nos études intègrent un départ ou un retour d'expatriation" paragraph="Notre expertise vous apporte une meilleure compréhension des impacts de l'expatriation: totalisation des périodes travaillées à l'étranger, études comparatrives selon les adhésions." />      

            <Core navigation={navigation} context={context} />

            <Footer />
            
            <ScrollRestoration />
        </>
    )
}